import React, { useEffect } from "react"
import { ReactSVG } from "react-svg"
import { graphql } from "gatsby"
import { FramedTextFieldsFragment } from "../../../../../../graphql-types"
import * as styles from "./framed-text.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"
import useWindowWidth from "../../../../../hooks/use-window-width"
import StructuredTextContent from "../structured-text-content/structured-text-content"

type FramedTextProps = {
  data: FramedTextFieldsFragment
}

const FramedText: React.FC<FramedTextProps> = ({ 
  data: { title, structuredText, image, backgroundColor, textColor } 
}) => {

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  const displayImg = (img, classes?): JSX.Element => {
    if (!img) return

    return img.format === "svg" ? (
      <ReactSVG className={classes} src={img.url} title={img.title} />
    ) : (
      <img src={img.url} alt={img.alt || ""} title={img.title} className={classes} />
    )
  }

  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(frameContainer => {
        if (window.scrollY >= elementOffset(frameContainer).top - 700) {
          transformItem(frameContainer.getElementsByClassName(styles.transformContainer)[0], 400)
        }
      })
    })
  }

  return (
    <div 
      className={styles.container} 
      style={{ 
        "--textColor": textColor?.hex ?? "#162B44", 
        "--backgroundColor": backgroundColor?.hex ?? "transparent"
      }}
    >
        <div className={styles.transformContainer}>
        <div className={styles.content}>
        {image && (
          <figure role="group" className={styles.imageContainer}>
            {displayImg(image, styles.image)}
          </figure>
        )}
        <div className={styles.textContent}>
          {title && <h2 className={styles.title}>{title}</h2>}
          <div className={styles.text}>
            <StructuredTextContent data={structuredText.value} isNotRichContent={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment FramedTextFields on DatoCmsFramedText {
    __typename
    id
    title
    structuredText {
      value
    }
    image {
      alt
      format
      title
      url
    }
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
  }
`

export default FramedText
